import axios from "axios";

function verifyFAPhoneCode(obj) {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_API}/api/user/verifyPhoneCode`;

    axios
      .post(url, obj)
      .then(async (response) => {
        resolve(true);
      })
      .catch((error) => {
        reject(false);
      });
  });
}
export default verifyFAPhoneCode;
